export default theme => ({
  root: {
    width: '90%',
    marginBottom: theme.spacing.unit * 2,
  },
  buttonBack: {
    marginRight: theme.spacing.unit,
    marginLeft: theme.spacing.unit,
    marginTop: theme.spacing.unit * 2,
    float: 'left',
  },
  buttonNext: {
    marginRight: theme.spacing.unit,
    marginLeft: theme.spacing.unit,
    marginTop: theme.spacing.unit * 2,
    float: 'right',
  },
  stepsCompleted: {
    display: 'inline-block',
  },
  instructions: {
    marginTop: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
    fontStyle: 'italic',
    fontSize: '0.875rem',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    fontWeight: '400',
    lineHeight: '1.5',
    letterSpacing: '0.01071em',
  },
  instructionLabel: {
    fontWeight: 500,
    fontStyle: 'normal',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  wizard: {
    marginBottom: theme.spacing.unit,
    backgroundColor: 'white',
    width: '100%',
    padding: theme.spacing.unit,
  },
  expansionPanel: {
    marginBottom: `24px !important`,
    marginTop: '-24px !important',
    marginLeft: '-24px',
    marginRight: '-24px',
    [theme.breakpoints.down('xs')]: {
      marginTop: 0,
      marginLeft: 0,
      marginRight: 0,
    },
  },
  stepIconText: {
    fontSize: theme.typography.pxToRem(7),
    transform: 'translateY(-1px)',
    fill: theme.palette.primary.contrastText,
    fontFamily: theme.typography.fontFamily,
  },
  stepIconRoot: {
    width: '2em',
    height: '2em',
    fontWeight: 'bold',
    display: 'block',
    color: theme.palette.text.disabled,
    '&$active': {
      color: theme.palette.orange,
    },
    '&$completed': {
      color: theme.palette.green,
    },
    '&$error': {
      color: theme.palette.red,
    },
  },
  active: {},
  completed: {},
  error: {},
  iconContainer: {
    marginTop: '-13px',
  },
  alternativeLabel: {
    left: 'calc(-50% + 28px)',
    right: 'calc(50% + 28px)',
  },
  stepLabelCompleted: {
    fontWeight: '400 !important',
  },
  stepLabelActive: {
    fontWeight: '500 !important',
  },
  // dotActive: {
  //   backgroundColor: theme.palette.orange,
  // },
  // dotActiveCompleted: {
  //   backgroundColor: theme.palette.green,
  // },
  expansionPanelDetailsRoot: {
    display: 'block',
  },
  // mobileStepperRoot: {
  //   background: '#fff',
  // },
  container: {
    [theme.breakpoints.up('xs')]: {
      marginTop: 24,
      maxWidth: '100vw',
    },
    [theme.breakpoints.up('sm')]: {
      marginTop: 0,
      maxWidth: 'calc(100vw - 128px)',
    },
    [theme.breakpoints.up('md')]: {
      maxWidth: 'calc(100vw - 103px)',
    },
  },
  summaryContent: {
    maxWidth: '100%',
  },
  // dotCompleted: {
  //   '&:nth-child(1)': { backgroundColor: '#000' },
  // },
})
